import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

export function FooterSection() {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        textAlign: "center",
        padding: "3rem 2rem",
        color: theme.palette.textDim,
        fontSize: "0.85rem",
        borderTop: `1px solid ${theme.palette.divider}`,
        maxWidth: "1200px",
        margin: "0 auto"
      }}
    >
      <Typography sx={{ color: "inherit", fontSize: "inherit" }}>
        &copy; {new Date().getFullYear()} Scott Brown &middot; scottdb.net
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "0.5rem 1.5rem",
          marginTop: "0.75rem"
        }}
      >
        <Box
          component="a"
          href="/privacy"
          sx={{
            color: theme.palette.accent,
            fontSize: "inherit",
            display: "inline-flex",
            alignItems: "center",
            minHeight: 44,
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" }
          }}
        >
          Privacy Policy
        </Box>
        <Box
          component="a"
          href="/terms"
          sx={{
            color: theme.palette.accent,
            fontSize: "inherit",
            display: "inline-flex",
            alignItems: "center",
            minHeight: 44,
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" }
          }}
        >
          Terms of Use
        </Box>
        <Box
          component="a"
          href="https://scottdb.atlassian.net/servicedesk/customer/portal/3"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: theme.palette.accent,
            fontSize: "inherit",
            display: "inline-flex",
            alignItems: "center",
            minHeight: 44,
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" }
          }}
        >
          Support
        </Box>
      </Box>
    </Box>
  );
}
